import apiClient from "./api";


export const getTotalManagerCount = async (domainId) => {
    let url = '/api/DomainUser/managers/count';
    if (domainId) {
        url += `?domainId=${domainId}`;
    }
    try {
        const response = await apiClient.get(url);
        return response.data;
    } catch (error) {
        // console.error("Erreur compteur managers :", error);
        throw error("Erreur compteur managers :", error);
    }
};


export const getTotalManagerCounts = async () => {
    try {
        const response = await apiClient.get('/api/DomainUser/count');
        return response.data;
    } catch (error) {
        // console.error("Erreur compteur domaines :", error);
        throw error("Erreur compteur domaines :", error);
    }
};


export const changeIsManager = async (accountId, domainId) => {
    try {
      const response = await apiClient.put(`/api/DomainUser/changeIsManager/${accountId}/${domainId}`);
      return response.data; // Retourne le nouveau statut de manager (true ou false)
    } catch (error) {
    //   console.error("Erreur lors de la modification du statut de manager", error);
      throw error("Erreur lors de la modification du statut de manager", error);
    }
  };

